export function shortTrackId(id: string): string {
  return id.slice(0, 8);
}
